export const REQUEST_FIELD_LIST = [
    'actypes',
    'departure',
    'country',
    'datefrom',
    'dateto',
    'nightsfrom',
    'nightsto',
    'mealbetter',
    'currency',
    'priceto',
    'pricefrom',
    'stars',
    'starsbetter',
    'regions',
    'subregions',
    'adults',
    'child',
    'ages',
    'meal',
    'hotels',
    'onpage',
];

export const REQUEST_FIELD_TO_URL_MAP = {
    departure: 'departure',
    country: 'country',
    datefrom: 's_departFrom',
    dateto: 's_departTo',
    nightsfrom: 's_nightsMin',
    nightsto: 's_nightsMax',
    adults: 's_adults',
    child: 's_kids',
    ages: 's_kids_ages'
}